import { Link } from "react-router-dom";
import { FadeUp } from "./Reveal";
import Marquee from "react-fast-marquee";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="cf-footer" className="relative bg-[#1A1C1A] text-[#F4F2F0] mt-24">
      <div className="border-b border-white/10 py-6 overflow-hidden">
        <Marquee gradient={false} speed={40} pauseOnHover={false}>
          <span className="font-serif italic text-[#F4F2F0]/90 text-4xl md:text-5xl px-8">Clarity, not confusion.</span>
          <span className="font-serif text-[#C26D5C] text-4xl md:text-5xl px-8">✦</span>
          <span className="font-serif italic text-[#F4F2F0]/90 text-4xl md:text-5xl px-8">Guidance, not guesswork.</span>
          <span className="font-serif text-[#C26D5C] text-4xl md:text-5xl px-8">✦</span>
          <span className="font-serif italic text-[#F4F2F0]/90 text-4xl md:text-5xl px-8">A plan, not a guess.</span>
          <span className="font-serif text-[#C26D5C] text-4xl md:text-5xl px-8">✦</span>
        </Marquee>
      </div>

      <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-20">
        <FadeUp>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-6">
            <div className="md:col-span-5">
              <h2 className="font-serif text-4xl md:text-6xl leading-none tracking-tight font-light">
                Ready to build a<br /> career on <em className="italic text-[#C26D5C]">purpose</em>?
              </h2>
              <Link
                to="/book"
                data-testid="footer-cta"
                className="inline-flex items-center gap-3 mt-8 text-[#F4F2F0] border-b border-[#F4F2F0] pb-1 hover:text-[#C26D5C] hover:border-[#C26D5C] transition-colors"
              >
                Book a Free Career Call <span aria-hidden>→</span>
              </Link>
            </div>

            <div className="md:col-span-2 md:col-start-8">
              <div className="overline text-[#F4F2F0]/60 mb-4">Navigate</div>
              <ul className="space-y-2">
                <li><Link to="/" className="hover:text-[#C26D5C] transition-colors">Home</Link></li>
                <li><Link to="/services" className="hover:text-[#C26D5C] transition-colors">Services</Link></li>
                <li><Link to="/blog" className="hover:text-[#C26D5C] transition-colors">Journal</Link></li>
                <li><Link to="/book" className="hover:text-[#C26D5C] transition-colors">Book a Call</Link></li>
                <li><Link to="/contact" className="hover:text-[#C26D5C] transition-colors">Contact</Link></li>
                <li><Link to="/legal" className="hover:text-[#C26D5C] transition-colors">Legal</Link></li>
              </ul>
            </div>

            <div className="md:col-span-3">
              <div className="overline text-[#F4F2F0]/60 mb-4">Get in touch</div>
              <p className="text-[#F4F2F0]/80 leading-relaxed">
                hello@careerfactors.co<br />
                +91 98100 12345
              </p>
              <p className="mt-4 text-sm text-[#F4F2F0]/70 leading-relaxed">
                Online nationwide.<br />
                Onsite drives for schools, colleges &amp; institutions.
              </p>
            </div>
          </div>
        </FadeUp>

        <div className="mt-20 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#F4F2F0]/60">
          <div>© {year} CareerFactors. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/legal#terms" className="hover:text-[#C26D5C] transition-colors">Terms &amp; Conditions</Link>
            <Link to="/legal#privacy" className="hover:text-[#C26D5C] transition-colors">Privacy Policy</Link>
            <Link to="/legal#disclaimer" className="hover:text-[#C26D5C] transition-colors">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
